import _ from 'lodash';
import template from './radniNalogWizardForm.html';

class RadniNalogWizardFormController {
    constructor($uibModal, DS, AppConfiguration, logger, $state) {
        this.step = 1;
        this.$uibModal = $uibModal;
        this.logger = logger;
        this.$state = $state;
        DS.findAll('ProtetskiRad').then(response => {
            this.protetski_rad = response;
        });
        this.datastore = () => {
            return DS;
        };
        this.fazeListView = AppConfiguration().getViewByEntityAndType('FazaNaloga', 'ListView');
        this.stavkeNalogaListView = AppConfiguration().getViewByEntityAndType('StavkaNaloga', 'ListView');
        this.fazeEditView = AppConfiguration().getViewByEntityAndType('FazaNaloga', 'EditView');
        this.stavkeCreateView = AppConfiguration().getViewByEntityAndType('StavkaNaloga', 'CreateView');
    }

    $onInit() {
        this.osnovniPodaciFields = this.fields[0];
        this.stavkeNalogaFields = this.fields[1];
        this.napomenaField = this.fields[2];
        this.model = angular.copy(this.item);
        this.model.stavke = [];
        this.model.faze = [];
        this.model.plan = { pozicije: [], veze: [] };
        this.groupedStavke = [];
    }

    show(step) {
        this.step = step;
    }

    next() {
        if (this.step < 4) {
            this.step++;
        }
    }

    prev() {
        if (this.step > 1) {
            this.step--;
        }
    }

    cancel() {
        const previousWindowKeyDown = window.onkeydown;
        swal(
            {
                title: 'Prekid unosa novog radnog naloga',
                text: 'Želite odustati od unosa novog radnog naloga?',
                type: 'warning',
                showCancelButton: true,
                closeOnConfirme: true
            },
            () => {
                window.onkeydown = previousWindowKeyDown;
                this.$state.go('dashboard');
            }
        );
    }

    resolveNazivProtetskogRada(stavka) {
        const item = _.find(this.protetski_rad, { id: stavka.protetski_rad });
        if (_.isUndefined(item)) {
            return '';
        }
        return item.naziv;
    }

    insertStavkuNaloga(pozicije) {
        const model = { pozicije: pozicije };

        const modal = this.$uibModal.open({
            component: 'stavkaNalogaForm',
            size: 'lg-extra',
            // windowClass: 'modal-lg-extra',
            resolve: {
                item: function() {
                    return model;
                }
            }
        });

        return modal.result.then(model => {
            const stavke = [];
            const plan = [];
            if (pozicije.length > 0) {
                pozicije.forEach(pozicija => {
                    stavke.push(Object.assign({}, model, { pozicija: pozicija }));
                });
            } else {
                stavke.push(Object.assign({}, model, { pozicija: null }));
            }
            this.model.stavke = [...this.model.stavke, ...stavke];
            this.groupStavke();

            this.model.stavke.map(s => {
                plan.push({ id: s.pozicija, protetski_rad: s.protetski_rad });
            });

            this.model.plan = { pozicije: [...plan], veze: [...this.model.plan.veze] };
        });
    }

    vezeClicked(veza) {
        const item = _.find(this.model.plan.veze, { id: veza.id, celjust: veza.celjust });
        if (_.isObject(item)) {
            const veze = this.model.plan.veze.filter(f => f.id !== item.id || f.celjust !== item.celjust);
            this.model.plan = Object.assign({}, this.model.plan, {
                veze: [...veze]
            });
        } else {
            this.model.plan = Object.assign({}, this.model.plan, { veze: [...this.model.plan.veze, veza] });
        }
    }

    groupStavke() {
        // grupiraj stavke naloga po protetskom radu
        // {
        //     "protetski_rad": 21,
        //     "pozicije": [
        //            12,
        //            22,
        //            18
        //     ],
        //     cjenik: 1
        // },
        const DS = this.datastore();
        const StavkaNaloga = DS.definitions['StavkaNaloga'].createInstance();
        this.groupedStavke = StavkaNaloga.group(this.model.stavke);
    }

    insertFazu() {
        const DS = this.datastore();
        const model = {
            radni_nalog: this.item.id
        };
        const view = this.fazeEditView;
        const modal = this.$uibModal.open({
            component: 'modalForm',
            size: 'lg',
            resolve: {
                item: function() {
                    return model;
                },
                view: function() {
                    return view;
                },
                formClass: function() {
                    return 'standard';
                }
            }
        });

        modal.result.then(model => {
            this.model.faze.push(model);
        });
    }

    deleteFazu(item) {
        this.model.faze = this.model.faze.filter(f => f !== item);
    }

    submit(item) {
        this.form.$setSubmitted(true);
        if (this.form.$invalid) {
            return;
        }
        // TODO: refaktorizirati kod tako da se više ne koriste veze
        item.veze = [...item.plan.veze];
        this.onSubmit({ item: item });
    }

    removeStavkuNaloga(item) {
        const plan = [];
        this.model.stavke = this.model.stavke.filter(stavka => {
            return !(stavka.protetski_rad === item.protetski_rad && stavka.cjenik === item.cjenik);
        });
        // osvježi plan
        this.model.stavke.map(s => {
            plan.push({ id: s.pozicija, protetski_rad: s.protetski_rad });
        });

        this.model.plan = { pozicije: [...plan], veze: [...this.model.plan.veze] };
        this.groupStavke();
    }
}

RadniNalogWizardFormController.$inject = ['$uibModal', 'DS', 'AppConfiguration', 'logger', '$state'];

const RadniNalogWizardFormComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: RadniNalogWizardFormController,
    controllerAs: 'vm',
    bindings: {
        fields: '<',
        item: '<',
        onSubmit: '&'
    }
};

export { RadniNalogWizardFormComponent };
export { RadniNalogWizardFormController };



// WEBPACK FOOTER //
// ./app/components/radniNalog/radniNalogWizardForm.component.js